//  状态小卡片
import './index.scss';
import React, { useMemo } from 'react';
export default function StatusCard({ stuList = [], // 枚举列
stuVal = '', // 当前值
noValue = false, // 是否存在value 值
record = null, // 当前行数据
stuCode = '', // value对应字段
 }) {
    const one = useMemo(() => {
        return stuList?.find((item) => {
            if (record) {
                return item.value === record[stuCode];
            }
            else {
                return item.value === stuVal;
            }
        });
    }, [stuList, record, stuVal, stuCode]);
    return (React.createElement("div", { className: 'status-card-info', style: { background: one?.color } },
        React.createElement("div", { style: { font: one?.font || '#333333' }, className: 'status' }, noValue ? stuVal : one?.label)));
}
